import axios from "axios";

const api_url = process.env.REACT_APP_API_URL

const axiosInstance = axios.create({
  baseURL: api_url
});


// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status === 401) {
//       store.dispatch(logout());
//       window.location.href = "/login";
//     }
//
//     return Promise.reject(error);
//   }
// );

// axiosInstance.interceptors.response.use(undefined, err => {
//   const status = err.response ? err.response.status : null;
//   if(status === 401){
//
//   }
// });

export default axiosInstance;
